module.exports = __webpack_public_path__ + "img/2025-ford-bronco.41428618.png";